import type {
  ResourceFilterStatus,
  SearchMembershipsSearchParams,
  TeamSearchParams,
} from '@/lib/api/types/teams';

export const teamsQueryKeys = {
  all: () => ['teams'],
  byLoop: (loopId: string) => ['teams', 'loop', loopId],
  teamInfo: () => ['teamInfo'],
  team: ({
    teamId,
    resourceStatus,
  }: {
    teamId?: number | null;
    resourceStatus?: ResourceFilterStatus;
  }) => ['teamInfo', teamId, resourceStatus],
  search: (params: TeamSearchParams = {}) => [
    'teams',
    'search',
    {
      query: params.query?.trim() ?? '',
      sortBy: params.sortBy ?? 'NAME',
      sortDirection: params.sortDirection ?? 'ASC',
      loopId: params.loopId?.trim() ?? null,
    },
    params.roleIds ?? [],
  ],
  searchTeamMembers: ({
    teamId,
    searchParams,
  }: {
    teamId?: number | null;
    searchParams: SearchMembershipsSearchParams | undefined;
  }) => ['teamInfo', teamId, searchParams],
  importTeamsSearch: ({ sourceType, instanceId }: { sourceType?: string; instanceId?: string }) => [
    'importTeamsSearch',
    {
      sourceType,
      instanceId,
    },
  ],
  lookup: ({
    ids,
    dateRange,
    teamRoleIds,
    skillIds,
    loopId,
  }: {
    ids: number[];
    dateRange: { from: string; to: string } | undefined;
    teamRoleIds?: number[];
    skillIds?: number[];
    loopId?: string;
  }) => [
    'teamsLookup',
    {
      ids,
      dateRange,
      teamRoleIds,
      skillIds,
      loopId: loopId ?? null,
    },
  ],
  syncStatus: () => ['teamsSyncStatus'],
  teamImportingCount: () => ['teamsImportingCount'],
  resourceMemberships: {
    all: () => ['resourceTeamMemberships'],
    detail: (resourceId: number) => ['resourceTeamMemberships', resourceId],
  },
};
